import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

const PrevArrow = ({ onClick }) => {
  return (
    <button className="gallery-control-prev" onClick={onClick}>
      <span className="icon-left-open" />
    </button>
  );
};

const NextArrow = ({ onClick }) => {
  return (
    <button className="gallery-control-next" onClick={onClick}>
      <span className="icon-right-open" />
    </button>
  );
};

const Gallery = ({ children }) => {
  return (
    <section className="gallery">
      <Slider fade={true} speed={400} prevArrow={<PrevArrow />} nextArrow={<NextArrow />}>
        {children}
      </Slider>
    </section>
  );
};

Gallery.propTypes = {
  children: PropTypes.array
};

export default Gallery;
